import Cookies from "js-cookie";
import { GAME_ID_COOKIE, PLAYER_ID_COOKIE } from "../constants";
import { useQuery } from "@tanstack/react-query";
import useAxiosInstance from "./utils/axiosIntance";

type GetCardsResponse = {
  isSuccess: boolean;
  cards: string[];
};
const useGetCards = () => {
  const axios = useAxiosInstance();
  const gameId = Cookies.get(GAME_ID_COOKIE) || "";
  const playerId = Cookies.get(PLAYER_ID_COOKIE) || "";

  return useQuery<GetCardsResponse>({
    queryKey: ["getCards", gameId, playerId],
    enabled: !!gameId && !!playerId,
    retry: 0,
    gcTime: Infinity,
    staleTime: Infinity, // Ensures data is never considered stale
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryFn: () => {
      return axios
        .get(`/game/getCards`, { withCredentials: true })
        .then((res) => res.data);
    },
  });
};

export default useGetCards;
